import React, { useRef } from 'react';
import logo from '../assets/logo.png';
import { FaFacebook, FaLinkedinIn, FaInstagram } from 'react-icons/fa';
import { Link } from 'react-router-dom';

import { FaArrowUp } from 'react-icons/fa6';
import Button from './Button';

const Footer = ({ top, setNavigateToSection }) => {
  const anchorRef = useRef(null);
  function getCurrentYear() {
    return new Date().getFullYear();
  }
  const currentYear = getCurrentYear();
  const scrollToTop = () => {
    anchorRef.current.click();
  };
  return (
    <div className="flex flex-col w-full">
      <div className="relative bg-primary flex flex-col lg:flex-row justify-between px-12 md:px-32 py-12 gap-12 items-start w-full">
        <div className="absolute flex flex-col items-center top-[-23px] right-[10px]">
          <a ref={anchorRef} href="#top_bar">
            <Button
              type="button"
              content={
                <div className="flex items-center justify-center px-2">
                  <FaArrowUp color="#ffffff" size={20} />
                </div>
              }
              loading={false}
              btnColor="secondary"
              padding="px-1 py-3"
              Style={'text-white w-max rounded-md'}
            />
          </a>

          <p className="font-rubik text-white mt-2">Back to Top</p>
        </div>
        <div className="flex flex-col gap-3 lg:w-[40%] mx-auto lg:mx-0">
          <div className="h-[75px] w-[94px] object-contain mx-auto lg:mx-0">
            <img src={logo} alt="ASEF_LOGO" srcset="" />
          </div>

          <p className="font-rubik text-white text-center lg:text-start text-lg flex item-center">
            Education is{' '}
            <div className="flex items-center ml-1">
              <p className="italic text-secondary">Fun</p>damental.
            </div>
          </p>

          <div className="w-fit mx-auto lg:mx-0 flex items-center gap-4">
            <div className="bg-white rounded-full p-[6px] cursor-pointer">
              <FaInstagram size={15} color="#01A653" />
            </div>

            <div className="bg-white rounded-full p-[6px] cursor-pointer">
              <FaFacebook size={15} color="#01A653" />
            </div>

            <div className="bg-white rounded-full p-[6px] cursor-pointer">
              <FaLinkedinIn size={15} color="#01A653" />
            </div>
          </div>
        </div>

        <div className="flex flex-col gap-3 w-full lg:w-[20%]">
          <h1 className="font-quicksand text-secondary font-bold text-center lg:text-start">
            {' '}
            Quick Links
          </h1>

          <div className="flex w-full justify-between lg:justify-start items-start gap-6 font-rubik text-white">
            <div className="flex flex-col gap-3">
              <a href="/">Home</a>
              <Link
                to={'/about-us'}
                onClick={() => {
                  setNavigateToSection('#team');
                }}
              >
                Our Team
              </Link>
              <Link
                to={'/about-us'}
                onClick={() => {
                  setNavigateToSection('#founder');
                }}
              >
                Our Founder
              </Link>
              <a
                href="https://docs.google.com/forms/d/e/1FAIpQLSeeo3xTiRMtpe4Kt5mfWPxSSwOFjs9n-OeKlRbyae3ncWlvWQ/viewform"
                target="_blank"
                rel="noreferrer"
              >
                Alumni Updates
              </a>
            </div>
            <div className="flex flex-col gap-3">
              <Link
                to={'/about-us'}
                onClick={() => {
                  setNavigateToSection('#who-we-are');
                }}
              >
                About Us
              </Link>

              <Link
                to={'/'}
                onClick={() => {
                  setNavigateToSection('#contact');
                }}
              >
                Contact Us
              </Link>
              <Link to={'/news'}>News & Updates</Link>
            </div>
          </div>
        </div>

        <div className="flex flex-col gap-3 w-full lg:w-[20%]">
          <h1 className="font-quicksand text-secondary font-bold text-center lg:text-start">
            {' '}
            Our Programs
          </h1>

          <div className="flex w-full justify-between lg:justify-start items-start gap-6 font-rubik text-white">
            <div className="flex flex-col gap-3">
              <Link to={'/programs/new-intake'} onClick={scrollToTop}>
                New Intake
              </Link>
              <Link to={'/programs/supplies'} onClick={scrollToTop}>
                Supply distribution
              </Link>
              <Link to={'/programs/graduate-meetings'} onClick={scrollToTop}>
                Graduate Meetings
              </Link>
            </div>
            <div className="flex flex-col gap-3">
              <Link to={'/programs/advisory-meetings'} onClick={scrollToTop}>
                Advisory Meetings
              </Link>
              <Link to={'/programs/school-visits'} onClick={scrollToTop}>
                School Visits
              </Link>
            </div>
          </div>
        </div>
      </div>
      <div className="flex item-center justify-center bg-primary border-t border-white/60 px-12 py-2 w-full">
        <p className="text-center text-white font-rubik">
          @Copyrights Asef {currentYear} All Rights Reserved.
        </p>
      </div>
    </div>
  );
};

export default Footer;
